import React from "react";
import PublicLayout from "../components/PublicLayout";
import useJsonLd from "../lib/useJsonLd";

const SITE_URL = "https://luckynightteer.com";

const SECTIONS = [
  {
    h: "What is Night Teer? — A Complete Guide to Lucky Night Teer",
    p: [
      "Night Teer, also popularly known as Lucky Night Teer or Shillong Night Teer, is a traditional archery-based lottery game played in the Indian state of Meghalaya. Every night, hundreds of thousands of players across Shillong, Guwahati, Assam, Nagaland, Manipur, Tripura and even overseas wait for the official Night Teer Result to be announced. The Night Teer number is decided by counting the total arrows that hit a target during a live archery session, and the last two digits of that count form the winning Teer number.",
      "This website — Lucky Night Teer / Night Teer Result — is the fastest and most trusted destination to view live Night Teer numbers, Common Number predictions, Dream Number chart, Previous Result history, Teer Calendar and reputed Teer counter list. Whether you play Night Teer for fun or for winning big, our platform is designed to be lightning fast, mobile-friendly and completely free of cost.",
    ],
  },
  {
    h: "Night Teer Timing — F/R at 10:00 PM and S/R at 11:00 PM",
    p: [
      "The Night Teer game is played in two rounds every day. The First Round (F/R) result is declared at 10:00 PM sharp and the Second Round (S/R) result is announced at 11:00 PM sharp. The declared Night Teer number is the last two digits of the total number of arrows that hit the target in that round.",
      "Players bet a small amount (usually starting from ₹1) on a two-digit number from 00 to 99. If the declared Night Teer Result matches the bet number, the player wins the prize as per the payout ratio of the counter — usually 80x for direct number, 8x for house or ending. This is why Night Teer is so popular: even a small stake can turn into a big win overnight.",
    ],
  },
  {
    h: "History of Teer in Meghalaya and North East India",
    p: [
      "Teer literally means \"arrow\" in Hindi. The game has its roots in the traditional Khasi tribal archery competitions of Meghalaya. What started as a friendly sport in the villages of the Khasi Hills eventually became a regulated lottery game recognised by the Meghalaya Amusements and Betting Tax Act, 1982. Today, Shillong Teer, Khanapara Teer, Juwai Teer and Night Teer are the most-played variants across the region.",
      "Night Teer, sometimes referred to as Lucky Night Teer, was introduced to fulfil the demand of players who work during the day and can only participate at night. Unlike the day-time Shillong Teer that plays at 3:45 PM and 4:45 PM, Night Teer plays at 10:00 PM and 11:00 PM, giving night-owl players the same thrill of winning.",
    ],
  },
  {
    h: "How to Play Night Teer — Step by Step",
    p: [
      "Step 1: Visit an authorised Teer counter (Reputed Counter) in your area or use an online Teer app. Buy a Teer ticket by selecting a 2-digit number between 00 and 99. Each ticket costs as low as ₹1 to ₹10.",
      "Step 2: The Night Teer archers shoot 30 arrows in the first round (10:00 PM) and 20 arrows in the second round (11:00 PM). The total number of arrows that hit the target is announced. The last two digits become the winning Night Teer number.",
      "Step 3: If your chosen number matches the declared Night Teer Result, collect your winnings from the counter. The typical Direct Number payout is 1:80, House is 1:80, and Ending is 1:8. Some counters offer even higher payouts.",
    ],
  },
  {
    h: "Common Number Explained — Direct, House and Ending",
    p: [
      "The Common Number is a set of two-digit numbers calculated by expert Teer analysts based on the past Night Teer Results, mathematical formulae and pattern recognition. On this website we publish the Night Teer Common Number for each day.",
      "Direct Number: The exact two-digit number expected to hit. Direct number payout is the highest (usually 1:80).",
      "House Number: The first digit (or tens digit) of the winning number. Payout is 1:8.",
      "Ending Number: The last digit (or units digit) of the winning number. Payout is 1:8.",
      "Please note: Common numbers are only predictions and there is no 100% guarantee of accuracy. Always play responsibly.",
    ],
  },
  {
    h: "Dream Number Chart — What Your Dreams Mean in Teer",
    p: [
      "In North East India, many Teer players believe that dreams carry lucky numbers. Our Dream Number chart lists 38+ common dreams — including quarrel between husband and wife, snake, dog, horse, elephant, marriage, death, water, fire, mountain and many more — along with the Direct, House and Ending numbers traditionally associated with them.",
      "For example: a dream of a Tiger is associated with Direct 9 and House 9. A dream about Fire suggests numbers ending in 5. A dream of a Snake suggests 09, 17, 37, 57, 77, 99. Check our full Dream Number page to find your lucky Teer number based on last night's dream.",
    ],
  },
  {
    h: "Previous Result Archive — Track Trends and Patterns",
    p: [
      "Our Previous Result page shows the complete archive of past Night Teer Results with newest dates listed at the top. You can scroll through weeks of F/R and S/R history for Shillong Night Teer and identify hot numbers, cold numbers, patterns and pairs. Serious Teer players use previous result trends to plan their common number bets.",
      "Use the Teer Calendar to click any date and instantly view the F/R and S/R result declared on that day. This makes it easy to look up specific historical Night Teer Results without scrolling through long tables.",
    ],
  },
  {
    h: "Is Night Teer Legal? — Legal Status of Teer in India",
    p: [
      "Yes. Teer, including Night Teer and Lucky Night Teer, is legal in the state of Meghalaya under the Meghalaya Amusements and Betting Tax (Amendment) Act, 1982 and the Meghalaya Regulation of the Game of Arrow Shooting and the Sale of Teer Tickets Rules, 2018. It is regulated by the state government and licensed archery clubs.",
      "In other states of India, the legality varies. Please check your local laws before playing Teer. This website is intended for information & entertainment purposes only and does not encourage betting where it is prohibited by law.",
    ],
  },
  {
    h: "Tips to Play Night Teer Responsibly",
    p: [
      "1. Set a daily budget and never exceed it — Teer is a game of luck, not a source of income.",
      "2. Never borrow money to play Teer. Only bet what you can afford to lose.",
      "3. Use Common Number, Dream Number and Previous Result as inputs, not as guaranteed answers.",
      "4. Play through authorised Reputed Counters only. Avoid unlicensed operators.",
      "5. If you feel Teer is affecting your mental health or finances, please seek help. Playing Teer must remain a form of entertainment and not become an addiction.",
    ],
  },
  {
    h: "Why Lucky Night Teer is the Best Night Teer Website",
    p: [
      "Live Night Teer Result updated at 10:00 PM and 11:00 PM every single day. Bookmark this site and simply refresh at result time — no ads pop-up, no login needed for viewing.",
      "Complete Common Number and Dream Number chart maintained by expert analysts and updated regularly.",
      "Newest-first Previous Result archive so that you can quickly see today's, yesterday's, this week's and this month's Night Teer numbers.",
      "Interactive Teer Calendar to click any date and see the result.",
      "Mobile-friendly, lightning fast, works even on slow 2G networks in the North East region.",
      "100% free of cost — no subscription, no hidden charges.",
      "Join our WhatsApp channel, Telegram channel, Facebook page and YouTube channel from the footer to receive Night Teer Result live notifications the moment they are declared.",
    ],
  },
  {
    h: "Frequently Asked Questions (FAQ) — Night Teer",
    p: [
      "Q. What time is Night Teer result declared? A. F/R at 10:00 PM and S/R at 11:00 PM every day, including Sundays and holidays (subject to weather).",
      "Q. Where can I check Lucky Night Teer Result online? A. Right here on this website. We publish the official Night Teer Result within minutes of the archery round ending.",
      "Q. How do I win at Night Teer? A. There is no guaranteed way to win. Study Common Numbers, Dream Numbers and Previous Result trends, but ultimately Teer is a game of luck.",
      "Q. Can I play Night Teer online? A. Yes, through authorised online Teer platforms available in Meghalaya. Please verify licence before depositing money.",
      "Q. Is Night Teer the same as Shillong Teer? A. They are related but different. Shillong Teer plays at 3:45 PM and 4:45 PM. Night Teer plays at 10:00 PM and 11:00 PM.",
      "Q. Is there a Night Teer app? A. Coming soon — our own Night Teer Android and iOS app will be launched from this website. Meanwhile, bookmark this page and add it to your home screen.",
    ],
  },
  {
    h: "Related Searches — People Also Look For",
    p: [
      "night teer result, night teer result today, lucky night teer, lucky night teer result, night teer common number, night teer dream number, shillong night teer, shillong night teer result, night teer previous result, night teer today, teer common number, teer dream number, meghalaya night teer, khanapara night teer, morning teer live result, night teer 10 pm result, night teer 11 pm result, night teer F/R, night teer S/R, night teer live, night teer online, night teer app, night teer calendar, teer target, teer direct house ending, teer live result, teer prediction, teer number tomorrow.",
    ],
  },
];

export default function Blog() {
  // Article schema
  useJsonLd("blog-article", {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline":
      "Night Teer Result Blog — Lucky Night Teer, Common Number, Dream Number & Previous Result Guide",
    "description":
      "Complete guide to Night Teer / Lucky Night Teer — timings, how to play, common number, dream number chart, previous result history, legal status and FAQs.",
    "author": { "@type": "Organization", "name": "Lucky Night Teer" },
    "publisher": {
      "@type": "Organization",
      "name": "Lucky Night Teer",
      "logo": { "@type": "ImageObject", "url": `${SITE_URL}/logo.svg` },
    },
    "datePublished": "2026-02-01",
    "dateModified": new Date().toISOString().slice(0, 10),
    "mainEntityOfPage": { "@type": "WebPage", "@id": `${SITE_URL}/blog` },
    "image": `${SITE_URL}/logo.svg`,
    "keywords":
      "night teer, night teer result, lucky night teer, shillong night teer, common number, dream number, previous result, teer calendar, F/R 10 PM, S/R 11 PM",
  });

  // FAQPage schema built from the FAQ section
  useJsonLd("blog-faq", {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What time is Night Teer result declared?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "F/R at 10:00 PM and S/R at 11:00 PM every day, including Sundays and holidays (subject to weather).",
        },
      },
      {
        "@type": "Question",
        "name": "Where can I check Lucky Night Teer Result online?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Right here on this website. We publish the official Night Teer Result within minutes of the archery round ending.",
        },
      },
      {
        "@type": "Question",
        "name": "How do I win at Night Teer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "There is no guaranteed way to win. Study Common Numbers, Dream Numbers and Previous Result trends, but ultimately Teer is a game of luck.",
        },
      },
      {
        "@type": "Question",
        "name": "Can I play Night Teer online?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes, through authorised online Teer platforms available in Meghalaya. Please verify licence before depositing money.",
        },
      },
      {
        "@type": "Question",
        "name": "Is Night Teer the same as Shillong Teer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "They are related but different. Shillong Teer plays at 3:45 PM and 4:45 PM. Night Teer plays at 10:00 PM and 11:00 PM.",
        },
      },
      {
        "@type": "Question",
        "name": "Is there a Night Teer app?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Coming soon — our own Night Teer Android and iOS app will be launched from this website. Meanwhile, bookmark this page and add it to your home screen.",
        },
      },
    ],
  });

  // Breadcrumb
  useJsonLd("blog-breadcrumb", {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
      { "@type": "ListItem", "position": 2, "name": "Blog", "item": `${SITE_URL}/blog` },
    ],
  });

  return (
    <PublicLayout title="Lucky Night Teer">
      <div className="nt-container mt-6 pb-8">
        <article className="bg-white rounded-xl border shadow-sm p-4 sm:p-6">
          <header className="mb-4">
            <h1
              className="font-display text-2xl sm:text-4xl leading-tight"
              data-testid="blog-title"
            >
              Night Teer Result Blog — Lucky Night Teer, Common Number, Dream
              Number &amp; Previous Result Guide
            </h1>
            <p className="text-slate-600 text-sm mt-2">
              Last updated: {new Date().toLocaleDateString("en-GB")} — By the
              Lucky Night Teer team
            </p>
          </header>

          {SECTIONS.map((s, i) => (
            <section key={i} className="mt-6" data-testid={`blog-section-${i}`}>
              <h2 className="font-display text-xl sm:text-2xl mb-2 text-[color:var(--nt-ink)]">
                {s.h}
              </h2>
              {s.p.map((p, j) => (
                <p
                  key={j}
                  className="text-[14px] sm:text-[15px] leading-relaxed text-slate-800 mb-3"
                >
                  {p}
                </p>
              ))}
            </section>
          ))}

          <section
            className="mt-8 bg-yellow-50 border-l-4 border-yellow-500 rounded-md p-4"
            data-testid="blog-disclaimer"
          >
            <h3 className="font-extrabold text-[color:var(--nt-ink)] mb-1">
              Disclaimer
            </h3>
            <p className="text-[13px] leading-relaxed text-slate-800">
              Night Teer / Lucky Night Teer is a game of luck. Common numbers,
              dream numbers and predictions on this website are based on
              calculations from past results and are not guaranteed. This
              website is for information &amp; entertainment purposes only.
              Please play responsibly and only if permitted by your local laws.
            </p>
          </section>
        </article>
      </div>
    </PublicLayout>
  );
}
